import { DividerList, LabeledListItem } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { Tag } from '@optimus-web/core';
import { WithProductId } from '@mews-commander/types';
import { useAccountingCategoryNames } from '../../queries/useAccountingCategoryNames';
import { useProductQuery } from '../../queries/useProductQuery';

export const AccountingTabContent = ({ productId }: WithProductId) => {
    const { accountingCategoryId, rebateAccountingCategoryId, canceledItemAccountingCategoryId } = useProductQuery({
        productId,
    });
    const data = useAccountingCategoryNames({
        accountingCategoryId,
        canceledItemAccountingCategoryId,
        rebateAccountingCategoryId,
    });

    return (
        <DividerList>
            <LabeledListItem label={lt('ProductAccountingCategoryCharged')}>
                {data?.chargedAccountingCategoryName ? (
                    <Tag variant="basicSubtle" outline>
                        {data.chargedAccountingCategoryName}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
            <LabeledListItem label={lt('ProductAccountingCategoryRebated')}>
                {data?.rebatedAccountingCategoryName ? (
                    <Tag variant="basicSubtle" outline>
                        {data.rebatedAccountingCategoryName}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
            <LabeledListItem label={lt('ProductAccountingCategoryCanceled')}>
                {data?.canceledItemAccountingCategoryName ? (
                    <Tag variant="basicSubtle" outline>
                        {data.canceledItemAccountingCategoryName}
                    </Tag>
                ) : (
                    UnicodeEntity.Dash
                )}
            </LabeledListItem>
        </DividerList>
    );
};
